import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PointsAccountFacade } from './facades/points-account/points-account.facade';
import { PointsAccountApiService } from './services/points-acccount-api/points-account-api.service';
import { PointsAccountEffects } from './store/effects/points-account.effects';
import { pointsAccountReducer } from './store/reducers/points-accounts.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('pointsAccount', pointsAccountReducer),
    EffectsModule.forFeature([PointsAccountEffects]),
  ],
  providers: [PointsAccountFacade, PointsAccountApiService],
})
export class PointsAccountModule {}
